export const RESOURCE_SELECTION_TAGS_PER_ROW = 2;
